import React, { useEffect } from "react";


const InterestRatePolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `The Reserve Bank of India (RBI) through its notification DNBS.204/CGM (ASR)-2009 dated January 2, 2009, and the Master Direction DNBR. PD. 007/03.10.119/2016-17 dated September 1, 2016, directs NBFCs and their Boards to review and implement internal interest rate models that factor in the cost of funds, margin, and risk premium. ${import.meta.env.VITE_COMPANY_NBFC} ("Company"), operating under the brand "${import.meta.env.VITE_COMPANY_NAME}," complies with these guidelines and has formulated this Interest Rate Policy in line with the Fair Practices Code.`,
    },
    {
      title: "2. Disclosure",
      content: `The Company's interest rate determination process—including applicable rates and charges—is transparently disclosed on its official website and shared with customers during the loan process.`,
    },
    {
      title: "3. Interest Rate",
      list: [
        "This policy is approved by the Board of Directors and incorporates key factors: cost of funds, margin, and risk premium.",
        "Rates vary by borrower based on risk profile, credit score, and operational costs.",
        "Loan amounts range from ₹5,000 to ₹1,20,000 with tenures between 7 and 45 days.",
        "APR ranges from 15% to 35% based on borrower profile, credit score, and loan terms.",
        "All loans are Fixed Rate and repaid through EMIs or Bullet repayment. Interest is payable on due date; penal interest applies for delays.",
      ],
    },
    {
      title: "4. Fees & Charges",
      list: [
        "Borrowers pay fees such as processing, credit assessment, or origination (10–15% of loan amount).",
        "Additional charges apply for EMI returns, rescheduling, or special services.",
        "Applicable taxes and cesses are levied as per law, and all revisions are prospective.",
        "Refunds or waivers may be granted solely at the Company's discretion.",
      ],
    },
    {
      title: "5. Customer Communication",
      content:
        "The final interest rate, applicable fees, and charges are clearly communicated to the borrower at loan sanction through a Sanction Letter and loan documentation. Borrowers receive a copy of the signed loan agreement after disbursal.",
    },
    {
      title: "6. Amendment",
      content:
        "This policy may be revised or updated at any time with the approval of the Board of Directors. All changes, once approved, take immediate effect.",
    },
  ];

  return (
    <div className="min-h-screen bg-[#EFFFFD] font-['Inter',sans-serif] pt-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-4">
            Interest Rate Policy
          </h1>
          <p className="text-lg text-[#2C3E50]/80 max-w-3xl mx-auto">
            At{" "}
            <span className="font-semibold text-[#21A6B5]">
              {import.meta.env.VITE_COMPANY_NAME}
            </span>
            , we follow transparent and responsible lending practices in line
            with the Reserve Bank of India's guidelines for NBFCs. This policy
            explains our approach to determining interest rates and lending
            charges.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-3">
              <h2 className="text-xl md:text-2xl font-bold text-[#2C3E50] border-b-2 border-[#21A6B5]/30 pb-2">
                {section.title}
              </h2>
              {section.content && (
                <p className="text-[#2C3E50]/80 text-base whitespace-pre-line leading-relaxed">
                  {section.content}
                </p>
              )}
              {section.list && (
                <ul className="list-disc list-outside ml-6 space-y-2 text-[#2C3E50]/80 text-base">
                  {section.list.map((li, i) => (
                    <li key={i} className="pl-1">{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default InterestRatePolicy;
